module.exports = __webpack_public_path__ + "img/de.78feb91b.svg";